module.exports = __webpack_public_path__ + "img/mobile-airport-authority-logo.d2fc3b6e.png";